var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{ref:"td",staticClass:"td vs-table--td",class:{ 'td-edit': _vm.$slots.edit }},[_c('span',{on:{"click":_vm.clicktd}},[(_vm.$slots.edit)?_c('vs-icon',{staticClass:"icon-edit",attrs:{"icon":"edit"}}):_vm._e(),_vm._t("default"),(_vm.$slots.edit)?_c('span',{staticClass:"empty"},[_vm._v(" "+_vm._s(_vm.data ? "" : "Empty")+" ")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }